import { __read, __spreadArray } from "tslib";
import { from } from '../observable/from';
import { concatAll } from '../operators/concatAll';
import { Observable } from '../Observable';
export function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return function (source) {
        return new Observable(function (subscriber) {
            concatAll()(from(__spreadArray([source], __read(otherSources), false))).subscribe(subscriber);
        });
    };
}
//# sourceMappingURL=concatWith.js.map